
import  axios  from 'axios';
import {CLEAR_A_TOWJOB_ERROR_MESSAGE, clearTowErrorMsgInStore} from "../towjob/actions";
import AppUtils from "../../../utils/AppUtils";


export const LOAD_CARD_DATA = 'card/LOAD_CARD_DATA';
export const DELETE_A_CARD = 'card/DELETE_A_CARD';
export const SAVE_A_CARD = 'card/SAVE_A_CARD';
export const UPDATE_A_CARD = 'card/UPDATE_A_CARD';
export const CLEAR_A_CARD_ERROR_MESSAGE = 'card/CLEAR_A_CARD_ERROR_MESSAGE';


export function clearCardErrorMsgInStore(){
    return {
        type: CLEAR_A_CARD_ERROR_MESSAGE,
        
    }
}

export function loadCardDataInStore(argCardDataArray) {
    return {
        type: LOAD_CARD_DATA,
        cardsData:argCardDataArray
    }
}
export function deleteACardDataInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_CARD,
        deleteCardResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveACardDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_CARD,
        saveCardResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateACardDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_CARD,
        updateCardResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

/********************* End of InStore calls **************************/

//****************************************
//Below is for update a Stream
//****************************************
export function clearCardErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearCardErrorMsgInStore());
    }
}
export function updateACard(argURL, argCamera) {
    return (dispatch, getState) => {
        const state = getState();
        updateACardOnServer(argURL, argCamera, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveACardDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error updating a card" + errorObj.statusText + errorObj.status);
            dispatch(saveACardDataInStore({}, errorObj));
        });
    }//end of return
}


function updateACardOnServer( argURL, argCamera, argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateACard(argURL, argCamera, argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a cards " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateACard(argURL, argCamera , argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/cards
     */

    let baseUrl = argURL+"users/"+argUserId+"/creditcards"+"/"+argCamera.id;
    console.log(" on posting a cardies the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argCamera, {headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveACard(argURL, argCamera) {
    return (dispatch, getState) => {
        const state = getState();
        saveACardOnServer(argURL, argCamera, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveACardDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error saving a card" + errorObj.statusText + errorObj.status);
            dispatch(saveACardDataInStore({}, errorObj));
        });
    }//end of return
}


function saveACardOnServer( argURL, argCamera, argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveACard(argURL, argCamera ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
               // console.log("Farshid some error occured on saving a cards " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveACard(argURL, argCardId ,argIdToken, argUserId ){


    let baseUrl = argURL+"users/"+argUserId+"/creditcards";
    console.log(" on posting a cardies the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCardId, {headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a card
//****************************************
export function deleteACard(argURL, argCameraId) {
    return (dispatch, getState) => {
        const state = getState();
        deleteACardOnServer(argURL, argCameraId,  state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){
            dispatch(deleteACardDataInStore(deleteResponse.data, {"status":deleteResponse.status, "statusText":deleteResponse.statusText}));
        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteACardDataInStore({}, errorObj));
        });
    }//end of return
}


function deleteACardOnServer( argURL, argStreamId, argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){
        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteACard(argURL, argStreamId, argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on deleteing a card " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteACard(argURL, argcardId ,argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+argUserId+"/creditcards"+"/"+argcardId;
    console.log(" on deleteing a card the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of cards

export function loadCardsData(argURL) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfCards(argURL, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(cardsList){

            dispatch(loadCardDataInStore(cardsList));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfCards(argURL ,argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/card
     */

    let baseUrl = argURL+"users/"+ argUserId+"/creditcards";
    console.log(" on getting list of Cards  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfCards( argURL, argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfCards(argURL, argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Cards " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}

/*
function getCardDataFromRemoteServer( argURL, argCardsList  ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if(argCardsList != null){

            axios.all(getArrayOfGets(argURL, argCardsList )).then(function(responses){
                resolve(responses);

            }, function(err) {
                console.log("Farshid some error occured " + err.message);
                reject(err);
            });
        }
    });

    return returnPromise;
}

*/

function getArrayOfGets(argURL, argFarmsList ){

    //let baseUrl =  "http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/METRIC_VALUES?";
    let baseUrl = argURL;

    /*

     I need to build something like this :

     http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/GRAPHS/farm_summary?farmId=f1
     */

    var arrayOfGets = [];
    if(argFarmsList != null) {
        for (var i = 0; i < argFarmsList.length; i++) {
                let responseData = argFarmsList[i];
                //let responseData = singleResponse.data;
                //if((argMetricList[i].checked != null) && (argMetricList[i].checked == true) ) {
                let tempURl = baseUrl + "GRAPHS" + "/farm_summary?farmId=" + responseData.id;
                console.log("Farshid the Card DATA URL is =" + tempURl);
                arrayOfGets.push(axios.get(tempURl));

            //}
        }
    }
    return arrayOfGets;


}

/*
export function loadCardData(argURL) {
    return (dispatch, getState) => {


        var arrayOfCardData=[];
        getListOfCards(argURL).then(function(cardsList){

            for(var z=0; z<cardsList.length; z++){

                let singleResponse = cardsList[z];
                let responseData = singleResponse.data;
                getCardDataFromRemoteServer(argURL,responseData ).then(function (farmsData){
                    for(var i=0; i<farmsData.length; i++) {
                        arrayOfCardData.push(farmsData[i].data);
                    }
                    dispatch(loadCardDataInStore(arrayOfCardData));

                }, function (err){
                    console.log("I had an error gettting Farms Data3333" + err);
                });

            }
    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
 */